module.exports = __webpack_public_path__ + "static/media/main_menu_event2.752f93db.svg";